import Preloader from '../../../../../ui/svg/common/preloader';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import React, { useState } from 'react';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { getLocalData } from '../../domain/shopping-cart-address-provider';
import { removeCredit } from '../../data/data-service';
import CartCoupon from '../../../../../ui/svg/shopping-cart/coupon';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';

const CreditItem = () => {
    const dispatch = useAppDispatch();

    const cartData = useAppSelector(store => store.root.cartData);
    const cartStep = useAppSelector(store => store.root.cartStep);

    const [ loading, setLoading ] = useState(false);

    const removeCreditHandler = async () => {
        setLoading(true);

        const response = await removeCredit(getLocalData());

        setLoading(false);

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        dispatch(
            rootActions.setCartData(response.data.relatedData)
        );

        dispatch(
            rootActions.main({
                isReferCreditChecked: true,
            })
        )

        sendGAEvent('Remove Credit', `Step ${ cartStep }`);
    };

    return (
        <div className="text-gray-700 border border-green rounded bg-green-100 px-3 py-2 flex items-center mt-4">
            <div className="text-green"><CartCoupon width="27" /></div>
            <div className="flex flex-col mx-4 flex-1">
                <div className="mb-1">
                    <div>Store Credit</div>
                </div>

                {
                    !loading &&
                    <button
                        type="button"
                        className="text-xs text-gray-500 text-left underline"
                        data-qa="cart-remove-coupon"
                        onClick={ removeCreditHandler }>Edit</button>
                }

                { loading && <Preloader width="15px" height="15px" color="#4f4f4f" /> }
            </div>
            <div className="text-green">
                -<ProductPriceFormat price={ cartData.priceData.selectedUserCredit || 0 } />
            </div>
        </div>
    )
};

export default CreditItem;